import request from '@/utils/request'

/**
* 小程序用户API
*
* @author ljw
* @since 2025/03/31
*/

/**
* 基础接口
*
* @type {string}
*/
export const BASE_URL = 'manage/applet-user'

/**
* 分页查询接口
*
* @type {string}
*/
export const PAGE_URL = `${BASE_URL}/page`

/**
* 查询指定ID的数据
*
* @param id ID
* @returns {Promise}
*/
export function get(id: any) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}

/**
 * 修改登录许可状态
 * @param data
 */
export function updateLoginPermission(data: any) {
  return request({
    url: `${BASE_URL}/updateLoginPermission`,
    method: 'put',
    data: data
  })
}